import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";

export const EaAssignCompany = ({ job, companies, onDone }) => {
  const [cid, setCid] = useState("");
  const [busy, setBusy] = useState(false);
  const d = job.detected || {};
  const run = async (action) => {
    setBusy(true);
    try {
      if (action === "assign") await api.post(`/ea/imports/${job.id}/assign`, { company_id: cid });
      else await api.post(`/ea/imports/${job.id}/cancel`);
      toast.success(action === "assign" ? "Cliente associato: import in coda" : "Import annullato, file eliminato");
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-3 rounded-xl border border-amber-300 bg-amber-50 p-3" data-testid={`ea-assign-${job.id}`}>
      <div className="flex items-start gap-2 text-sm text-amber-900">
        <AlertTriangle size={16} className="mt-0.5 flex-shrink-0" />
        <div>
          <b>{d.identifier_type} {d.identifier}</b> non è associato a nessun cliente.
          {d.company_name && <> Nel file: <i>{d.company_name.replace(/\.$/, "")}</i>.</>} Scegli il cliente oppure annulla l&apos;import.
        </div>
      </div>
      <div className="mt-2 flex items-center gap-2 flex-wrap">
        <select
          value={cid}
          onChange={(e) => setCid(e.target.value)}
          className="px-3 py-1.5 rounded-lg border border-slate-300 bg-white text-sm min-w-[260px]"
          data-testid={`ea-assign-select-${job.id}`}
        >
          <option value="">Seleziona cliente…</option>
          {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <button
          disabled={!cid || busy}
          onClick={() => run("assign")}
          className="px-3 py-1.5 rounded-lg bg-purple-600 text-white text-sm font-semibold disabled:opacity-40"
          data-testid={`ea-assign-confirm-${job.id}`}
        >
          Associa e importa
        </button>
        <button
          disabled={busy}
          onClick={() => run("cancel")}
          className="px-3 py-1.5 rounded-lg border border-slate-300 bg-white text-sm"
          data-testid={`ea-assign-cancel-${job.id}`}
        >
          Annulla import
        </button>
      </div>
    </div>
  );
};

export default EaAssignCompany;
